import React, {Fragment, useContext, useEffect, useRef, useState} from 'react'
import { Dialog, Transition } from '@headlessui/react'
import {OrderContext} from "../../context/OrderContext";
import {UserContext} from "../../context/UserContext";
import {APICreateOrderTender} from "../../api/orders/OrdersTender";
import { SelectList } from '../formFields/selectList';
import { SelectInput } from '../formFields/selectInput';
import {APIGetPlanCreator} from "../../api/companies/Creators";
import {APICreateContract} from "../../api/orders/OrdersContracts";
import {APIPostOrderLinkedMessaging} from "../../api/orders/OrdersMessaging";
import {TfiClose} from "react-icons/tfi";
import {SelectBox} from "#src/components/formFields/selectBox";


export default function StartTender() {
    const { user } = useContext(UserContext);
    const {showBidModal,setShowBidModal, saveOrder, order  } = useContext(OrderContext);
    const [planCreator,setPlanCreator] = useState(null);
    const cancelButtonRef = useRef(null);
    const [planCreators, setPlanCreators] = useState([]);
    const [tenderType, setTenderType ] = useState("xplanung24");
    const [contractedCompany, setContractedCompany] = useState(null);

    const creators = [
        {id: "4bc746b3-2a02-4cab-b342-13f12c843fe8", name: "Spacedatists"},
        {id: "f03c270c-aaa8-418b-b06d-0ef10ac4b84e", name: "geoGLIS"},
        {id: "a8a07a27-3e97-4c22-a692-3cd491a3cbb9", name: "BKI."},
        {id: "306adc01-56ec-4160-b1b3-80f17f2aa5ee", name: "RMK"},
        //{id: "a911b7ff-4509-431d-b5ed-e517d75c1640", name: "TS Company"},
    ]

    useEffect(() => {
        getPlanCreator();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function getPlanCreator() {
        await APIGetPlanCreator(user.companyId).then((data) => {setPlanCreator(data)});
    }

    const startTender = async () => {
        if(typeof order?.id !== "undefined") {
            const bidData = {
                bidProcess: tenderType,
                planCreators: planCreators,
            }

            await APICreateOrderTender(order?.id, bidData?.bidProcess, bidData, user)
                .then((data) => {saveOrder("inTender",order?.id)})
                .then((data)=> {setShowBidModal(false)})
        }
    }

    const directContracting = async () => {
        if(typeof order?.id !== "undefined") {

            let companyName = ""
            const bidData = {
                bidProcess: tenderType,
                contractedCompany: contractedCompany,
            }

            for(const a of planCreator) {
                if(bidData?.contractedCompany === a.id) {
                    companyName = a.name
                }
            }

            const messageData = {
                ordersId : order?.id,
                linkId : order?.id,
                linkType : "progressUpdate",
                createdByUser : user?.id,
                createdByUserName : user?.name,
                createdByCompany : user?.companyId,
                createdByCompanyName : user?.companyId,
                message : "Auftrag direkt vergeben an: "+companyName +" durch Auftraggeber",
                orderCompany: order?.createdByCompany,
                contractedCompany: order?.contractedCompany,
                planId: order?.planId,
            }

            // create Contract
            
            const tender = await APICreateOrderTender(order?.id, bidData?.bidProcess, bidData, user)
            APICreateContract(order?.id, tender?.id , null, bidData?.contractedCompany, user, "directSelection");
            APIPostOrderLinkedMessaging({messageData, companyId: user.companyId})
                .then((data)=> {saveOrder("contracted", order?.id)})
                .then((data)=> {setShowBidModal(false)});

        }
    }

    return (
        <Transition.Root show={showBidModal} as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setShowBidModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-8 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >

                            <Dialog.Panel className='flex max-w-3xl flex-col max-h-full sm:max-h-max h-full md:h-auto rounded-lg bg-white text-left shadow-xl transition-all w-full relative'>
                                <button
                                    type='button'
                                    className='absolute z-40 lg: lg:-top-6 lg:-right-6 top-2 right-2'
                                    onClick={() => setShowBidModal(false)}
                                    ref={cancelButtonRef}
                                >
                                    <TfiClose className={"lg:size-16 border-gray-500/80 border-2 bg-white hover:bg-gray-300 lg:p-4 size-12 p-2 lg:rounded-full rounded-md"}/>
                                </button>


                                <div className='block md:flex w-full h-full'>
                                    <div className={'flex flex-col w-full'}>
                                        <div className='p-4 md:p-8 flex flex-col flex-1  overflow-y-auto'>
                                            {/* Bid Data */}
                                            <h4 className={"text-xl font-bold"}>Angebot einholen</h4>
                                            <div className='flex h-full  flex-col'>
                                                <div className="px-4 mt-12 sm:gap-4 sm:px-0">
                                                    <div className=" text-sm  flex rounded-xl cursor-pointer justify-between text-center" >
                                                     <span onClick={() => setTenderType("xplanung24")} className={(tenderType === "xplanung24") ? "bg-white  border-gray-900 border-2 py-3 border-b-0 -m-1 rounded-t-xl w-1/2 z-10": " text-gray-600/60  border-white border-2  py-2 w-1/2 rounded-xl" }>
                                                        Kostenloses Angebot anfordern
                                                     </span>
                                                                            <span onClick={() => setTenderType("directSelection")} className={(tenderType === "directSelection") ? "bg-white   border-gray-900 border-2 border-b-0 py-3 -m-1 rounded-t-xl w-1/2 z-10": "text-gray-600/60  border-white border-2 py-2 w-1/2 rounded-xl"}>
                                                        Direkt Experten-Büro zuweisen
                                                     </span>
                                                    </div>

                                                    {(tenderType === "xplanung24") && (
                                                        <div className={"border-gray-900 border-2 rounded-b-xl p-8 mt-[2px] -mx-[4px]"}>
                                                            <p className={"text-sm  leading-6 text-gray-600/60  mb-8"}>Möchten Sie ein kostenloses Angebot für Ihren Auftrag erhalten? Wählen Sie einfach die Experten-Büros, von denen Sie ein Angebot anfordern möchten. Wir informieren Sie umgehend, sobald das Angebot für Sie bereitsteht.</p>

                                                            <dl className="divide-y divide-gray-100 ">
                                                                <div className=" sm:gap-4 sm:px-0">
                                                                    <SelectList
                                                                        label={""}
                                                                        size={'small'}
                                                                        options={creators}
                                                                        requested={false}
                                                                        value={planCreators}
                                                                        setValue={setPlanCreators}
                                                                        selectAll={true}
                                                                    />
                                                                </div>
                                                            </dl>
                                                        </div>
                                                    )}
                                                    {(tenderType === "directSelection") && (
                                                        <div className={"border-gray-900 border-2 rounded-b-xl p-8 mt-[2px] -mx-[4px]"}>
                                                            <p className={"text-sm leading-6 text-gray-600/60  mb-8"}>Möchten Sie den Auftrag direkt einem Experten-Büro zuweisen? In diesem Fall wird der Auftrag sofort an das ausgewählte Partner-Büro übermittelt, und es erfolgt keine Angebotseinholung mehr.</p>

                                                            <div
                                                                className=" py-2 sm:gap-4 sm:px-0">
                                                                <SelectBox
                                                                    label={""}
                                                                    options={creators}
                                                                    requested={false}
                                                                    value={contractedCompany}
                                                                    setValue={setContractedCompany}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                </div>
                                            </div>

                                        </div>
                                        <div className="p-8 sm:flex-row-reverse flex w-full flex-col-reverse gap-4">
                                            {(tenderType === "directSelection") ? (
                                                <button
                                                    type="button"
                                                    className={`text-center truncate items-center rounded-md bg-white border-gray-900 border-2 px-4 py-3 text-sm font-semibold text-gray-900 disabled:border-gray-500 disabled:text-gray-500 disabled:cursor-not-allowed`}
                                                    disabled={(tenderType === "" || contractedCompany === null || contractedCompany === "") }
                                                    onClick={() => {
                                                        directContracting()
                                                    }}
                                                >
                                                    Auftrag direkt zuweisen
                                                </button>
                                            ):(
                                                <button
                                                    type="button"
                                                    className={`text-center truncate items-center rounded-md bg-white border-gray-900 border-2 px-4 py-3 text-sm font-semibold text-gray-900 disabled:border-gray-500 disabled:text-gray-500 disabled:cursor-not-allowed`}
                                                    disabled={(tenderType === "" || planCreators.length === 0) }
                                                    onClick={() => {
                                                        startTender()
                                                    }}
                                                >
                                                    Angebote einholen
                                                </button>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>

                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
